import registry from '../utils/registry';

const componentRegistry = registry();
export { componentRegistry as default };
